import i18n from '@/i18n';
import { toCurrency } from '@/utils';
import { toFormattedDate } from '@/utils/date';

// Labels call i18n.t(), so they must be re-evaluated on every use (from a computed) to react
// to a runtime locale switch.
export const getBaseStreamFieldDefinitions = () => [
  {
    key: 'employee_code',
    label: i18n.t('employee.assignments.columns.employeeCode'),
    sortable: true,
  },
  {
    key: 'full_name',
    label: i18n.t('shifts.fields.employee'),
    sortable: true,
  },
  {
    key: 'created_at',
    label: i18n.t('payschedules.returnedSalaries.dateHeader'),
    sortable: true,
    formatter: value => toFormattedDate(value),
  },
  {
    key: 'net_amount',
    label: i18n.t('payschedules.returnedSalaries.amountHeader'),
    sortable: true,
    formatter: value => toCurrency(value),
  },
];

export const STREAM_FIELD_KEYS = {
  EMPLOYEE_CODE: 'employee_code',
  FULL_NAME: 'full_name',
  PAY_SCHEDULE_NAME: 'pay_schedule_name',
  NET_AMOUNT: 'net_amount',
  CREATED_AT: 'created_at',
  TYPE: 'type',
};

export const STREAM_FILTER_KEYS = {
  STARTS_ON: 'starts_on',
  ENDS_ON: 'ends_on',
  SALARY_OR_HOURLY: 'salary_or_hourly',
  PAY_SCHEDULE: 'pay_schedule_id',
  DIVISION: 'division',
};

export const STREAM_API_FILTER_KEYS = [
  STREAM_FILTER_KEYS.STARTS_ON,
  STREAM_FILTER_KEYS.ENDS_ON,
  STREAM_FILTER_KEYS.PAY_SCHEDULE,
];

export const STREAM_SEARCH_FIELDS = ['created_at', 'full_name', 'employee_code'];

export const STREAM_PER_PAGE_OPTIONS = [25, 50, 100];
